import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function ExamResult() {
  const navigate = useNavigate();
  const { id } = useParams();

  const resultData = {
    examId: id,
    examName: 'الرياضيات المتقدمة',
    referenceNumber: 'EX-2024-001234',
    score: 85,
    totalScore: 100,
    percentage: 85,
    passingScore: 60,
    status: 'ناجح',
    correctAnswers: 25,
    wrongAnswers: 3,
    unanswered: 2,
    totalQuestions: 30,
    timeSpent: '45 دقيقة',
    averageScore: 72,
    rank: 12,
    totalStudents: 150,
    submittedAt: '2024-02-01 10:45 صباحاً'
  };

  const performanceAnalysis = [
    { topic: 'التفاضل والتكامل', score: 90, total: 100, status: 'ممتاز' },
    { topic: 'المعادلات التفاضلية', score: 85, total: 100, status: 'جيد جداً' },
    { topic: 'الجبر الخطي', score: 80, total: 100, status: 'جيد جداً' },
    { topic: 'نظرية الأعداد', score: 75, total: 100, status: 'جيد' },
    { topic: 'الهندسة التحليلية', score: 88, total: 100, status: 'ممتاز' }
  ];

  const recommendations = [
    'ركز على تحسين مهاراتك في نظرية الأعداد',
    'راجع المعادلات التفاضلية من الدرجة الثانية',
    'تدرب أكثر على مسائل الجبر الخطي المعقدة',
    'استمر في أدائك الممتاز في التفاضل والتكامل'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3]">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        {/* Success Header */}
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl p-8 mb-8 text-white text-center">
          <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
            <i className="ri-checkbox-circle-line text-6xl"></i>
          </div>
          <h1 className="text-4xl font-bold mb-3">تم إرسال إجاباتك بنجاح!</h1>
          <p className="text-xl text-white/90 mb-4">رقم مرجعي: {resultData.referenceNumber}</p>
          <p className="text-white/80">تم الإرسال في: {resultData.submittedAt}</p>
        </div>

        {/* Score Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">النتيجة النهائية</h2>
            <div className="relative inline-block">
              <svg className="w-48 h-48" viewBox="0 0 200 200">
                <circle
                  cx="100"
                  cy="100"
                  r="80"
                  fill="none"
                  stroke="#E5E7EB"
                  strokeWidth="20"
                />
                <circle
                  cx="100"
                  cy="100"
                  r="80"
                  fill="none"
                  stroke="#1ABC9C"
                  strokeWidth="20"
                  strokeDasharray={`${(resultData.percentage / 100) * 502.4} 502.4`}
                  strokeLinecap="round"
                  transform="rotate(-90 100 100)"
                />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-5xl font-bold text-[#1ABC9C]">{resultData.percentage}%</span>
                <span className="text-slate-600 mt-2">{resultData.status}</span>
              </div>
            </div>
            <div className="mt-6 flex items-center justify-center gap-8">
              <div>
                <p className="text-3xl font-bold text-[#0F2A3A]">{resultData.score}</p>
                <p className="text-slate-600">درجتك</p>
              </div>
              <div className="w-px h-12 bg-slate-300"></div>
              <div>
                <p className="text-3xl font-bold text-slate-400">{resultData.totalScore}</p>
                <p className="text-slate-600">الدرجة الكلية</p>
              </div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid md:grid-cols-4 gap-4">
            <div className="p-4 bg-green-50 rounded-xl text-center">
              <i className="ri-checkbox-circle-line text-3xl text-green-600 mb-2"></i>
              <p className="text-2xl font-bold text-green-600">{resultData.correctAnswers}</p>
              <p className="text-sm text-slate-600">إجابات صحيحة</p>
            </div>
            <div className="p-4 bg-red-50 rounded-xl text-center">
              <i className="ri-close-circle-line text-3xl text-red-600 mb-2"></i>
              <p className="text-2xl font-bold text-red-600">{resultData.wrongAnswers}</p>
              <p className="text-sm text-slate-600">إجابات خاطئة</p>
            </div>
            <div className="p-4 bg-yellow-50 rounded-xl text-center">
              <i className="ri-question-line text-3xl text-yellow-600 mb-2"></i>
              <p className="text-2xl font-bold text-yellow-600">{resultData.unanswered}</p>
              <p className="text-sm text-slate-600">لم تُجب</p>
            </div>
            <div className="p-4 bg-blue-50 rounded-xl text-center">
              <i className="ri-time-line text-3xl text-blue-600 mb-2"></i>
              <p className="text-2xl font-bold text-blue-600">{resultData.timeSpent}</p>
              <p className="text-sm text-slate-600">الوقت المستغرق</p>
            </div>
          </div>
        </div>

        {/* Comparison & Performance */}
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {/* Comparison */}
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-bold text-[#0F2A3A] mb-6">مقارنة مع المتوسط</h3>
            <div className="space-y-6">
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-slate-600">درجتك</span>
                  <span className="font-bold text-[#1ABC9C]">{resultData.percentage}%</span>
                </div>
                <div className="w-full h-3 bg-slate-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#1ABC9C]"
                    style={{ width: `${resultData.percentage}%` }}
                  ></div>
                </div>
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-slate-600">متوسط الطلاب</span>
                  <span className="font-bold text-slate-400">{resultData.averageScore}%</span>
                </div>
                <div className="w-full h-3 bg-slate-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-slate-400"
                    style={{ width: `${resultData.averageScore}%` }}
                  ></div>
                </div>
              </div>
              <div className="pt-4 border-t border-slate-200">
                <div className="flex items-center justify-between">
                  <span className="text-slate-600">ترتيبك</span>
                  <span className="text-2xl font-bold text-[#1ABC9C]">
                    {resultData.rank} من {resultData.totalStudents}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Performance by Topic */}
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-bold text-[#0F2A3A] mb-6">الأداء حسب الموضوع</h3>
            <div className="space-y-4">
              {performanceAnalysis.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-slate-700 font-semibold">{item.topic}</span>
                    <span className="text-sm font-bold text-[#0F2A3A]">{item.score}%</span>
                  </div>
                  <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden">
                    <div
                      className={`h-full ${
                        item.score >= 85 ? 'bg-green-500' : item.score >= 70 ? 'bg-blue-500' : 'bg-yellow-500'
                      }`}
                      style={{ width: `${item.score}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Recommendations */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h3 className="text-xl font-bold text-[#0F2A3A] mb-6">توصيات تعليمية ذكية</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {recommendations.map((rec, index) => (
              <div key={index} className="flex items-start gap-3 p-4 bg-blue-50 rounded-xl">
                <div className="w-6 h-6 flex items-center justify-center bg-blue-500 rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-lightbulb-line text-white text-sm"></i>
                </div>
                <p className="text-slate-700 leading-relaxed">{rec}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-4 justify-center">
          <button
            onClick={() => navigate('/home')}
            className="px-8 py-4 bg-[#0F2A3A] text-white font-semibold rounded-xl hover:bg-[#1a3d52] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line ml-2"></i>
            العودة للرئيسية
          </button>
          <button
            onClick={() => navigate('/results')}
            className="px-8 py-4 bg-[#1ABC9C] text-white font-semibold rounded-xl hover:bg-[#16a085] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-bar-chart-box-line ml-2"></i>
            عرض جميع النتائج
          </button>
          <button
            className="px-8 py-4 bg-white text-[#0F2A3A] border-2 border-[#0F2A3A] font-semibold rounded-xl hover:bg-slate-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-line ml-2"></i>
            تحميل التقرير
          </button>
        </div>
      </div>
    </div>
  );
}
